import { createSlice } from '@reduxjs/toolkit';
import { BIOENTITY_INITIAL_STATE } from './bioEntity.constants';
import {
  clearBioEntitySearchDataReducer,
  getBioEntityReducer,
  getMultiBioEntityReducer,
  toggleIsContentTabOpenedReducer,
} from './bioEntity.reducers';

export const bioEntityContentsSlice = createSlice({
  name: 'bioEntityContents',
  initialState: BIOENTITY_INITIAL_STATE,
  reducers: {
    toggleIsContentTabOpened: toggleIsContentTabOpenedReducer,
    clearBioEntitySearchData: clearBioEntitySearchDataReducer,
  },
  extraReducers: builder => {
    getMultiBioEntityReducer(builder);
    getBioEntityReducer(builder);
  },
});

export const { toggleIsContentTabOpened, clearBioEntitySearchData } =
  bioEntityContentsSlice.actions;

export default bioEntityContentsSlice.reducer;
